export const customsRoutesOptions = [
    { value: 1, description: 'IE-GB', portEntryAuth: 'GMR', portExitAuth: 'PBN' },
    { value: 2, description: 'GB-IE', portEntryAuth: 'PBN', portExitAuth: 'GMR' },
]